import { FSBathroomSubFeature, mapFSBathroomSubFeatures } from "./BathroomSubFeature";

// Bathroom feature
export interface FSBathroomFeature {
    id: number;
    feature_name: string;
    status: 1 | 0;
    sub_feature?: FSBathroomSubFeature[];
}

export const mapFSBathroomFeature = (data: any): FSBathroomFeature => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBathroomFeature = {
        id: data.id,
        feature_name: data.feature_name,
        status: data.status,
        sub_feature: Array.isArray(data.sub_feature) ? mapFSBathroomSubFeatures(data.sub_feature) : [],
    };

    return res;
};

export const mapFSBathroomFeatures = (data: any[]): FSBathroomFeature[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBathroomFeature);
};